import React from "react";

export default function Datenschutz() {
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-12 py-16 sm:py-20" data-testid="datenschutz-page">
      <div className="text-xs uppercase tracking-[0.3em] text-terracotta mb-4">— Rechtliches</div>
      <h1 className="font-display text-4xl sm:text-5xl text-ink leading-tight">Datenschutzerklärung</h1>
      <p className="mt-4 text-sm text-ink-muted">Stand: Februar 2026</p>

      <div className="mt-10 space-y-8 text-ink leading-relaxed text-[15px]">
        <section>
          <h2 className="font-display text-2xl mb-3">1. Verantwortliche Stelle</h2>
          <p>
            <strong>Regula Müller – Ayurveda Aargau</strong><br />
            Obere Feldeggstr. 13, 5614 Sarmenstorf<br />
            Aarestrasse 20, 5102 Rupperswil<br />
            E-Mail: <a href="mailto:contact@ayurveda-aargau.ch" className="text-terracotta hover:underline">contact@ayurveda-aargau.ch</a>
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl mb-3">2. Allgemeine Hinweise</h2>
          <p>
            Wir nehmen den Schutz deiner persönlichen Daten sehr ernst und behandeln deine
            personenbezogenen Daten vertraulich und entsprechend der schweizerischen
            Datenschutzgesetzgebung (DSG) sowie der EU-Datenschutzgrundverordnung (DSGVO),
            sofern diese Anwendung findet.
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl mb-3">3. Erhebung und Verarbeitung von Daten</h2>
          <p>
            Bei einer Online-Buchung oder Gutschein-Bestellung erfassen wir die für die
            Auftragsabwicklung notwendigen Daten: Name, E-Mail, Telefon, Adresse,
            Geburtsdatum (optional) sowie deine ausgewählte Behandlung und der Termin.
            Diese Daten werden ausschliesslich zur Bearbeitung deiner Anfrage verwendet
            und nicht an Dritte weitergegeben.
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl mb-3">4. Cookies & Tracking</h2>
          <p>
            Diese Webseite verwendet Cookies sowie folgende Drittanbieter-Dienste, sofern
            du im Cookie-Banner zustimmst:
          </p>
          <ul className="mt-3 space-y-2 list-disc pl-5">
            <li>
              <strong>Google Analytics 4</strong> – zur anonymisierten Reichweitenmessung.
              IP-Adressen werden anonymisiert. Anbieter: Google Ireland Limited, Gordon House,
              Barrow Street, Dublin 4, Irland.
            </li>
            <li>
              <strong>Meta Pixel (Facebook)</strong> – zur Conversion-Messung und für
              Werbeanzeigen. Anbieter: Meta Platforms Ireland Ltd., 4 Grand Canal Square,
              Dublin 2, Irland.
            </li>
            <li>
              <strong>Stripe</strong> – zur sicheren Zahlungsabwicklung von Online-Gutschein-Käufen.
              Anbieter: Stripe Payments Europe Ltd., 1 Grand Canal Street Lower, Dublin, Irland.
            </li>
          </ul>
          <p className="mt-3">
            Du kannst deine Einwilligung jederzeit widerrufen, indem du in deinem Browser
            die für diese Domain gespeicherten Daten löschst.
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl mb-3">5. E-Mail-Kommunikation</h2>
          <p>
            Nach einer Buchung erhältst du automatisch eine Bestätigungs-E-Mail. Der E-Mail-Versand
            erfolgt über unseren Schweizer SMTP-Anbieter Hostpoint AG (Stackmail).
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl mb-3">6. Speicherdauer</h2>
          <p>
            Buchungs- und Kundendaten werden so lange aufbewahrt, wie es für die
            Geschäftsbeziehung erforderlich oder gesetzlich vorgeschrieben ist
            (in der Regel 10 Jahre gemäss schweizerischem Obligationenrecht).
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl mb-3">7. Deine Rechte</h2>
          <p>
            Du hast jederzeit das Recht auf Auskunft, Berichtigung, Löschung oder
            Einschränkung der Verarbeitung deiner personenbezogenen Daten sowie das
            Recht auf Datenübertragbarkeit. Wende dich dazu an{" "}
            <a href="mailto:contact@ayurveda-aargau.ch" className="text-terracotta hover:underline">
              contact@ayurveda-aargau.ch
            </a>
            .
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl mb-3">8. SSL-Verschlüsselung</h2>
          <p>
            Diese Webseite nutzt aus Sicherheitsgründen eine SSL-Verschlüsselung (HTTPS).
            Du erkennst dies am Schloss-Symbol in der Adresszeile deines Browsers.
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl mb-3">9. Änderungen</h2>
          <p>
            Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets
            den aktuellen rechtlichen Anforderungen entspricht.
          </p>
        </section>
      </div>
    </div>
  );
}
